import { BaseService } from './BaseService';
import createTemplate from '@/graphql/mutations/QuoteTemplateCreate.gql';
import quoteTemplateDelete from '@/graphql/mutations/QuoteTemplateDelete.gql';
import quoteTemplateLoad from '@/graphql/mutations/QuoteTemplateLoad.gql';
import templateSearch from '@/graphql/queries/QuoteTemplateSearch.gql';
import upsertBillItems from '@/graphql/mutations/BillItemsUpsert.gql';
import upsertBillItemTemplate from '@/graphql/mutations/BillItemTemplate/Upsert.gql';
import deleteBillItemTemplate from '@/graphql/mutations/BillItemTemplate/Delete.gql';
import {
  BillItemInput,
  BillItemFields,
  QuoteTemplateCreate,
  QuoteTemplateInput,
  QuoteTemplateLoadInput,
  deleteQuoteTemplate,
  loadQuoteTemplate,
  quoteTemplateSearch,
  TaxTypeEnum
} from '@/types/graphql/schemaTypes';
import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';

class BillItemService extends BaseService {
  public upsertBillItems(billItemsArgs: BillItemInput[], shipmentId: string):
    Promise<FetchResult<BillItemFields>> {
    return this.client.mutate({
      mutation: upsertBillItems,
      variables: {
        billItemsArgs,
        shipmentId
      }
    });
  }

  public fetchTemplates(): Promise<ApolloQueryResult<quoteTemplateSearch>> {
    return this.client.query({
      query: templateSearch
    });
  }

  /**
   * Apply template to a shipment
   * @param loadArgs : object with of shipmentId and quoteTemplateId
   * @returns boolean
   */
  public loadTemplate(loadArgs: QuoteTemplateLoadInput):
  Promise<FetchResult<loadQuoteTemplate>> {
    return this.client.mutate({
      mutation: quoteTemplateLoad,
      variables: {
        quoteTemplateLoadArgs: loadArgs
      }
    });
  }

  public createTemplate(quoteTemplateArgs: QuoteTemplateInput):
    Promise<FetchResult<QuoteTemplateCreate>> {
    return this.client.mutate({
      mutation: createTemplate,
      variables: {
        quoteTemplateArgs
      }
    });
  }

  /**
   * Delete quote templates
   * @param quoteTemplateIds : array of quoteTemplateId
   */
  public deleteTemplate(quoteTemplateIds: string[]): Promise<FetchResult<deleteQuoteTemplate>> {
    return this.client.mutate({
      mutation: quoteTemplateDelete,
      variables: {
        quoteTemplateIds
      }
    });
  }

  public upsertBillItemTemplate(description: string, taxType: TaxTypeEnum, category?: string, id?: string) {
    return this.client.mutate({
      mutation: upsertBillItemTemplate,
      variables: {
        biItemTemplateArgs: {
          description: description,
          taxType: taxType,
          category: category,
          id: id
        }
      }
    });
  }

  public deleteBillItemTemplate(id: string) {
    return this.client.mutate({
      mutation: deleteBillItemTemplate,
      variables: {
        id: id
      }
    });
  }
}

export const billItemService = new BillItemService();
